import { useFormikContext, Field } from "formik";
import { useFormikWizard } from "formik-wizard";
import React from "react";

function Pension() {
  const { errors, touched } = useFormikContext();
  const formik = useFormikWizard();

  return (
    <div>
 <h2 class="heading1">Income from pensions</h2>
    <p>Provide details about any pensions you receive. </p>
    <p>Not all options will be relevant to you. Answer all relevant questions and provide as accurate information as possible.</p>
    <fieldset>
        <div class="question-section">
            <div class="form__control form__input">
                <label class="heading3 mbottom-10" htmlFor="statepension">State Pension</label>
                <span class="inline pound-font">£</span>
                <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$"  id="statepension" name="statepension_name" class="input-width--300"/>
            </div>
            <div class="form__control form__radio">
                <Field type="radio" id="pension-per-weekly" name="statepension_per" value="0"/>
                <label class="form__label" htmlFor="pension-per-weekly"><span>Weekly</span></label>
            </div>
            <div class="form__control form__radio">
                <Field type="radio" id="pension-per-monthly" name="statepension_per" value="1"/>
                <label class="form__label" htmlFor="pension-per-monthly"><span>Four weekly</span></label>
            </div>
        </div>
        <div class="question-section form__control form__input">
            <label class="heading3 mbottom-10" htmlFor="privatepensions">Private Pensions</label>  
            <span class="inline pound-font">£</span>
           
            <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$"id="privatepensions" name="privatepensions_name" class="input-width--300"/>
            <div>
                <div class="form__control form__radio">
                    <Field type="radio" id="privatepension-per-weekly" name="privatepension_per" value="0"/>
                    <label class="form__label" htmlFor="privatepension-per-weekly"><span>Weekly</span></label>
                </div>
                <div class="form__control form__radio">
                    <Field type="radio" id="privatepension-per-monthly" name="privatepension_per" value="1"/>
                    <label class="form__label" htmlFor="privatepension-per-monthly"><span>Monthly</span></label>
                </div>
                {formik.values.valuecare.typeofcare === '1' && 
                //Only show this if they have selected "Residential" as type of care
                    <div class="radio__reveal"  data-togglefieldsetfrom="residential--shortstay" data-togglefieldsetdisplay="1">
                    <h3>Do you want to pass 50% of your private pensions to a spouse or partner?</h3>
                    <div class="form__control form__radio">
                        <Field type="radio" id="passpensionon_yes" name="passpensionon" value="1"/>
                        <label class="form__label" htmlFor="passpensionon_yes"><span>Yes</span></label>
                    </div>
                    <div class="form__control form__radio">
                        <Field type="radio" id="passpensionon_no" name="passpensionon" value="0"/>
                        <label class="form__label" htmlFor="passpensionon_no"><span>No</span></label>
                    </div>
                    </div> 
                }
                 

            </div>
        </div>
        
       
        <div class="question-section">
            <label class="heading3 mbottom-10" htmlFor="pensioncredit">Pension Credit (Guaranteed Credit)</label>  
            <div class="form__control form__input">
                <span class="inline pound-font">£</span>
              
                <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$"  id="pensioncredit" name="pensioncredit_name" class="input-width--300"/>
            </div>
            <div>
                <div class="form__control form__radio">
                    <Field type="radio" id="pensioncredit-per-weekly" name="pensioncredit_per"value="0"/>
                    <label class="form__label" htmlFor="pensioncredit-per-weekly"><span>Weekly</span></label>
                </div>
                <div class="form__control form__radio">
                    <Field type="radio" id="pensioncredit-per-monthly" name="pensioncredit_per"value="1"/>
                    <label class="form__label" htmlFor="pensioncredit-per-monthly"><span>Four weekly</span></label>
                </div>
            </div>
        </div>
        <div class="question-section">
            <h3 class="heading3">Pension Credit (Savings Credit)</h3>  
            <div class="form__control form__input">    
                <label class="form__label" htmlFor="pensionsavingscredit">Enter your pension credit savings credit in pounds</label>
                <span class="inline pound-font">£</span>
                <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="pensionsavingscredit" name="pensionsavingscredit_name" class="input-width--300"/>
            </div>
            <div>
                <div class="form__control form__radio">
                    <Field type="radio" id="pensionsavingscredit-per-weekly" name="pensionsavingscredit_per" value="0"/>
                    <label class="form__label" htmlFor="pensionsavingscredit-per-weekly"><span>Weekly</span></label>
                </div>
                <div class="form__control form__radio">
                    <Field type="radio" id="pensionsavingscredit-per-monthly" name="pensionsavingscredit_per" value="1"/>
                    <label class="form__label" htmlFor="pensionsavingscredit-per-monthly"><span>Four weekly</span></label>
                </div>
            </div>
        </div>   
    </fieldset>
    </div>
  );
}
export default Pension;